import { render, staticRenderFns } from "./delivery-rate-grid.vue?vue&type=template&id=6003de2f"
import script from "./delivery-rate-grid.vue?vue&type=script&lang=js"
export * from "./delivery-rate-grid.vue?vue&type=script&lang=js"
import style0 from "./delivery-rate-grid.vue?vue&type=style&index=0&id=6003de2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports